
import { useLocation } from 'react-router-dom';
import { TRC_ROUTES } from '../constants/trcRoutes';


const DISPLAY_NAMES = {
  [TRC_ROUTES.LESSON_PLANS]: 'Lesson Plan',
  [TRC_ROUTES.RESOURCES]: 'Resources',
};

const BUTTON_LABELS = {
  [TRC_ROUTES.LESSON_PLANS]: 'Read Lesson Plan',
  [TRC_ROUTES.RESOURCES]: 'View Resource',
};

export const useTrcCategoryForDynamicButton = (fallbackCategory = '') => {
  const location = useLocation();
  const parts = (location?.pathname || '').split('/').filter(Boolean);
  const categoryFromPath = parts[1] || '';

  const category = categoryFromPath || fallbackCategory;

  const normalized = category.toLowerCase();


  const displayCategory =
    DISPLAY_NAMES[normalized] ||
    fallbackCategory ||
    category.replace(/-/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase());

  const buttonLabel = BUTTON_LABELS[normalized] || 'Open';

  return { category: normalized, displayCategory, buttonLabel };
};
